import React, { useState } from 'react';
import classnames from 'classnames';
import { Col, Nav, NavItem, NavLink, Row } from 'reactstrap';

const TabsOptionsList = [
  { label: "Devices Log", key: 'device' },
  { label: "System Logs", key: 'system' },
  { label: 'OOBM Logs', key: 'oob' }
]

function NavLogBar(props) {
  const { selected, onTabChange } = props;

  return (
    <Row>
      <Col sm={12}>
        <Nav tabs>
          {TabsOptionsList.map((option, index) => (
            <NavLink
              className={classnames({ active: selected === option.key })}
              style={{ cursor: 'pointer' }}
              onClick={() => onTabChange(option.key)}
              key={index}
            >
              {option.label}
            </NavLink>
          ))
          }
        </Nav>
      </Col>
    </Row>
  );
}

export default NavLogBar;
